import React from "react";
import ServiceSection, { ServiceSectionProps } from "./base";
import { Card, CardContent, Typography } from "@mui/material";
import Grid2 from "@mui/material/Unstable_Grid2/Grid2";

const ServiceSectionFeePlan = (props: ServiceSectionProps) => {
  const items = props.service.detail.fee_plan_section.items
  const columnSize: number = 12 / items.length
  return (
    <ServiceSection service={props.service} headline={props.headline || "料金プラン"}>
      <Grid2 container spacing={{ sm: 2, md: 3 }}>
        {items.map((item, index: number) => {
          return (
            <Grid2 sm={12} md={columnSize}>
              <Card key={index} sx={{padding: "8px", height: "100%" }}>
                <CardContent>
                  <Typography variant="h5" sx={{ fontWeight: "900" }}>
                    {item.title}
                  </Typography>
                  <Typography variant="body1">
                    料金: {item.price}
                  </Typography>
                  <Typography variant="body1" sx={{ fontSize: "0.8em"}}>
                    {item.contents.join("")}
                  </Typography>
                </CardContent>
              </Card>
            </Grid2>
          )
        })}
      </Grid2>
      <Typography variant="body2" sx={{ marginTop: "48px" }}>
        ※上記の料金プランは、ヒヤリング段階または見積り段階でお伝えいたします。上記のプランは、あくまでも目安としてご利用いただくようお願いします。
      </Typography>
    </ServiceSection>
  )
}

export default ServiceSectionFeePlan